import * as R from 'remeda';
import { markValuesWithLineNumbers } from '.';
import { IntlLocale, supportedLocales } from './config';
import en from './en/en.json';

const toFileName = (locale: IntlLocale) => {
  if (locale === 'zh') {
    return 'zh_CN' as const;
  }
  return locale;
};

export const getTranslationsByLocale = async (locale: IntlLocale) => {
  const fileName = toFileName(locale);
  const translations: { default: Record<string, string> } = R.isIncludedIn(
    locale,
    supportedLocales
  )
    ? await import(`./${fileName}/${fileName}.json`)
    : { default: {} };

  return {
    ...markValuesWithLineNumbers(en),
    ...markValuesWithLineNumbers(translations.default),
  };
};
